export default "__VITE_ASSET__81beb484__"